// Disabling this because we don't use it

export type Log = {
  level: string;
  message: string;
  timestamp: string;
  sessionId?: string;
};

export class LogProxy {
  static async log(): Promise<void> {
    // do nothing
  }
}
